import React from 'react';
import PropTypes from "prop-types";

export default function SuccessAlertSVG(props) {
  return (
    <svg
      width={props.styles.width}
      height={props.styles.height}
      id={props.id || ''}
      className={props.className || ''}
      viewBox="0 0 32 32" version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="#ffffff" fillRule="evenodd">
        <g id="Group" fill="#ffffff">
          <path id="Fill-success" fill="#00B44C" d="M16,1 C24.2653061,1 31,7.73469388 31,16 C31,24.2653061 24.2653061,31 16,31 C7.73469388,31 1,24.2653061 1,16 C1,7.73469388 7.73469388,1 16,1 Z M21.4750771,10.9389913 C20.8870816,10.492328 20.051088,10.6069938 19.605758,11.1923227 L19.605758,11.1923227 L14.5604631,17.8176056 L12.3831464,15.0362934 C11.9298165,14.4549645 11.0898229,14.353632 10.5111607,14.8082952 C9.93116508,15.261625 9.82983251,16.1002853 10.2831624,16.6789476 L10.2831624,16.6789476 L13.5258044,20.8215827 C13.7791358,21.1442469 14.1657995,21.3335788 14.5751297,21.3335788 L14.5751297,21.3335788 C14.9977931,21.3309121 15.3857902,21.136247 15.636455,20.8069161 L15.636455,20.8069161 L21.7270752,12.8069771 C22.1737385,12.2216482 22.060406,11.3856546 21.4750771,10.9389913 Z"></path>
        </g>
      </g>
    </svg>
  );
}

SuccessAlertSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
